import React from 'react';

const NoMacth = () => {
    return (
        <div>
            <img src="https://i1.wp.com/saedx.com/blog/wp-content/uploads/2019/01/saedx-blog-featured-70.jpg?fit=1200%2C500&ssl=1" alt=""/>
        </div>
    );
};

export default NoMacth;